module.exports = __webpack_public_path__ + "img/carshinaused_11.9409e407.jpg";